import { brandConfig } from "./brandConfig";

/* Domains where users must install the new APK (force banner + copy link).
 * The list itself lives in apkCopyLinkDomains.ts and is shipped only as hashes
 * (the "apkCopyLink" list in vite.config.ts). */

export const isApkCopyLinkDomain = (hostname?: string): boolean =>
  brandConfig.isListedDomain("apkCopyLink", hostname);
